export const getDropdownValue = (event) => {
  const raw = event?.value ?? event ?? undefined
  if (raw === null || raw === undefined) return undefined
  if (typeof raw === 'string') return raw
  if (typeof raw === 'object') {
    if (typeof raw.value === 'string') return raw.value
    if (typeof raw.descripcion === 'string') return raw.descripcion
    if (typeof raw.label === 'string') return raw.label
  }
  return undefined
}
